export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14252.a4fa680d.jpg";